import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import StudentLifePage from "./pages/StudentLifePage";
import SafetyPage from "./pages/SafetyPage";
import ServicesPage from "./pages/ServicesPage";
import FAQsPage from "./pages/FAQsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/student-life" element={<StudentLifePage />} />
          <Route path="/safety" element={<SafetyPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
